import { render } from "./LbrxOrdersSideBarPortrait.vue?vue&type=template&id=2e3fe856"
import script from "./LbrxOrdersSideBarPortrait.vue?vue&type=script&lang=js"
export * from "./LbrxOrdersSideBarPortrait.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__